import { Sandpack } from "@codesandbox/pitcher-client";
import { PitcherBrowserClient } from "@codesandbox/pitcher-client/dist/esm/browser";
import type { BrowserFSClient } from "@codesandbox/pitcher-client/dist/esm/browser/clients/FSClient";
import type { BrowserFileClient } from "@codesandbox/pitcher-client/dist/esm/browser/clients/file/FileClient";
import type { SandpackClient } from "@codesandbox/sandpack-client";
import { useEditor } from "features/editor/Feature";
import type { TestTabParams } from "features/types/tabs";
import { usePitcher } from "features/utils/usePitcher";
import { Box, Icon, Stack, Text, styled } from "prism-react";
import { useCallback, useState } from "react";

import type { TabPanelProps } from "../types";

import { TestRunner } from "./TestRunner";

export const TestsDevtool: React.FC<TabPanelProps<TestTabParams>> = () => {
  const [sandpackClient, setSandpackClient] = useState<SandpackClient>();
  const editor = useEditor();

  const isBrowserSandbox = editor.type === "sandbox" && !editor.isCloud;

  const sandbox = useEditor();
  const pitcher = usePitcher();

  const connectSandpack = useCallback((node: HTMLIFrameElement) => {
    if (pitcher instanceof PitcherBrowserClient && sandbox.type === "sandbox") {
      const sandpack = new Sandpack(
        sandbox,
        pitcher.clients.fs as BrowserFSClient,
        pitcher.clients.file as BrowserFileClient,
        pitcher.filesState,
      );

      sandpack?.mount(node).then(() => {
        setSandpackClient(sandpack.client);
      });
    }
  }, []);

  if (!isBrowserSandbox) {
    return (
      <StyledBox css={{ padding: "$6" }}>
        <Text>Test runner not supported</Text>
      </StyledBox>
    );
  }

  return (
    <StyledBox>
      <iframe
        ref={connectSandpack}
        style={{ display: "none" }}
        title="Sandpack: test runner"
      />

      {sandpackClient ? (
        <TestRunner client={sandpackClient} />
      ) : (
        <Stack css={{ padding: "$6" }} gap={1} horizontal>
          <Icon size={4} type="progress" />
          <Text>Loading</Text>
        </Stack>
      )}
    </StyledBox>
  );
};

const StyledBox = styled(Box, {
  background: "var(--vscode-tab-activeBackground, $neutral-fg-base)",
  height: "100%",
  position: "relative",
});
